
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const JobVisibility = {
  VISIBLE_EXTERNALLY: 'VISIBLE_EXTERNALLY',
  INTERNAL_ONLY: 'INTERNAL_ONLY',
  HIDDEN: 'HIDDEN'
} as const

export type JobVisibility = (typeof JobVisibility)[keyof typeof JobVisibility]


export const ProcessingStatus = {
  INIT: 'INIT',
  SUBMITTED: 'SUBMITTED',
  WORKING: 'WORKING',
  EXTRACT_ACTIVITY: 'EXTRACT_ACTIVITY',
  QUEUED: 'QUEUED',
  BASIC_PROFILE_EXTRACTED: 'BASIC_PROFILE_EXTRACTED',
  PARSE_PROFILE: 'PARSE_PROFILE',
  UPDATED_FACTORS: 'UPDATED_FACTORS',
  PROCESSED: 'PROCESSED',
  ERROR: 'ERROR',
  DUPLICATE: 'DUPLICATE'
} as const

export type ProcessingStatus = (typeof ProcessingStatus)[keyof typeof ProcessingStatus]


export const EmploymentType = {
  FULL_TIME: 'FULL_TIME',
  PART_TIME: 'PART_TIME',
  INTERNSHIP: 'INTERNSHIP',
  TRAINEE: 'TRAINEE'
} as const

export type EmploymentType = (typeof EmploymentType)[keyof typeof EmploymentType]


export const ApplicationType = {
  DIRECT: 'DIRECT',
  REFERRAL: 'REFERRAL',
  INTERNAL: 'INTERNAL',
  CONSULTANT: 'CONSULTANT'
} as const

export type ApplicationType = (typeof ApplicationType)[keyof typeof ApplicationType]


export const RelationshipType = {
  INDUSTRY_COLLEAGUE: 'INDUSTRY_COLLEAGUE',
  FAMILY_MEMBER: 'FAMILY_MEMBER',
  DONT_KNOW_PERSONALLY: 'DONT_KNOW_PERSONALLY',
  FRIEND: 'FRIEND',
  CO_WORKER: 'CO_WORKER',
  BATCH_MATE: 'BATCH_MATE'
} as const

export type RelationshipType = (typeof RelationshipType)[keyof typeof RelationshipType]


export const ReferralStatus = {
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED'
} as const

export type ReferralStatus = (typeof ReferralStatus)[keyof typeof ReferralStatus]


export const LivenessVerificationStatus = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  NOT_ENABLED: 'NOT_ENABLED'
} as const

export type LivenessVerificationStatus = (typeof LivenessVerificationStatus)[keyof typeof LivenessVerificationStatus]


export const WhatsappStep = {
  GET_CONSENT: 'GET_CONSENT',
  SELECT_LANGUAGE: 'SELECT_LANGUAGE',
  COLLECTING_DATA: 'COLLECTING_DATA',
  COMPLETED: 'COMPLETED',
  GET_RESUME: 'GET_RESUME',
  FAILED: 'FAILED'
} as const

export type WhatsappStep = (typeof WhatsappStep)[keyof typeof WhatsappStep]


export const TalentPoolInviteStatus = {
  PENDING: 'PENDING',
  SENT: 'SENT',
  FAILED: 'FAILED',
  APPLIED: 'APPLIED',
  ADDED_TO_JOB: 'ADDED_TO_JOB'
} as const

export type TalentPoolInviteStatus = (typeof TalentPoolInviteStatus)[keyof typeof TalentPoolInviteStatus]


export const InterviewFinalStatus = {
  REJECTED: 'REJECTED',
  OFFERED: 'OFFERED',
  ON_HOLD: 'ON_HOLD'
} as const

export type InterviewFinalStatus = (typeof InterviewFinalStatus)[keyof typeof InterviewFinalStatus]


export const PanellistRecommendation = {
  SELECTED: 'SELECTED',
  REJECTED: 'REJECTED',
  NEEDS_ANOTHER_ROUND: 'NEEDS_ANOTHER_ROUND',
  PENDING: 'PENDING',
  ON_HOLD: 'ON_HOLD'
} as const

export type PanellistRecommendation = (typeof PanellistRecommendation)[keyof typeof PanellistRecommendation]


export const InterviewRoundType = {
  SCREENING: 'SCREENING',
  INTERVIEW: 'INTERVIEW',
  BOTH: 'BOTH'
} as const

export type InterviewRoundType = (typeof InterviewRoundType)[keyof typeof InterviewRoundType]


export const PanellistFeedbackStatus = {
  PENDING: 'PENDING',
  WORKING: 'WORKING',
  COMPLETED: 'COMPLETED'
} as const

export type PanellistFeedbackStatus = (typeof PanellistFeedbackStatus)[keyof typeof PanellistFeedbackStatus]


export const JobLevel = {
  ENTRY: 'ENTRY',
  MID: 'MID',
  SENIOR: 'SENIOR'
} as const

export type JobLevel = (typeof JobLevel)[keyof typeof JobLevel]


export const PhoneQuestionType = {
  objective: 'objective',
  subjective: 'subjective'
} as const

export type PhoneQuestionType = (typeof PhoneQuestionType)[keyof typeof PhoneQuestionType]


export const ScreeningInterviewStatus = {
  INIT: 'INIT',
  QUESTIONS_GENERATED: 'QUESTIONS_GENERATED',
  DEVICE_SETUP: 'DEVICE_SETUP',
  INTERVIEW_STARTED: 'INTERVIEW_STARTED',
  INTERVIEW_DONE: 'INTERVIEW_DONE',
  RESULT_IN_PROGRESS: 'RESULT_IN_PROGRESS',
  RESULT_COMPLETED: 'RESULT_COMPLETED'
} as const

export type ScreeningInterviewStatus = (typeof ScreeningInterviewStatus)[keyof typeof ScreeningInterviewStatus]


export const ScreeningCallStatus = {
  INIT: 'INIT',
  SCHEDULED: 'SCHEDULED',
  IN_PROGRESS: 'IN_PROGRESS',
  RESCHEDULED: 'RESCHEDULED',
  DECLINED: 'DECLINED',
  COMPLETED: 'COMPLETED',
  RESULT_IN_PROGRESS: 'RESULT_IN_PROGRESS',
  RESULT_COMPLETED: 'RESULT_COMPLETED',
  FAILED: 'FAILED'
} as const

export type ScreeningCallStatus = (typeof ScreeningCallStatus)[keyof typeof ScreeningCallStatus]


export const ScreeningInterviewTransport = {
  DAILY_JS: 'DAILY_JS',
  FASTRTC: 'FASTRTC'
} as const

export type ScreeningInterviewTransport = (typeof ScreeningInterviewTransport)[keyof typeof ScreeningInterviewTransport]


export const ScreeningRecordingStatus = {
  INIT: 'INIT',
  UPLOADING: 'UPLOADING',
  FINALIZING: 'FINALIZING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
} as const

export type ScreeningRecordingStatus = (typeof ScreeningRecordingStatus)[keyof typeof ScreeningRecordingStatus]


export const CustomFieldType = {
  TEXT: 'TEXT',
  NUMBER: 'NUMBER',
  SWITCH: 'SWITCH',
  CHECKBOX: 'CHECKBOX',
  AUTOCOMPLETE: 'AUTOCOMPLETE',
  FILEUPLOAD: 'FILEUPLOAD',
  TEL: 'TEL'
} as const

export type CustomFieldType = (typeof CustomFieldType)[keyof typeof CustomFieldType]


export const JDStatus = {
  DRAFT: 'DRAFT',
  REVIEW: 'REVIEW',
  APPROVED: 'APPROVED',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED'
} as const

export type JDStatus = (typeof JDStatus)[keyof typeof JDStatus]


export const InviteResponseType = {
  CANDIDATE: 'CANDIDATE',
  PANELLIST: 'PANELLIST'
} as const

export type InviteResponseType = (typeof InviteResponseType)[keyof typeof InviteResponseType]


export const InviteResponseStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
  TENTATIVE: 'TENTATIVE'
} as const

export type InviteResponseStatus = (typeof InviteResponseStatus)[keyof typeof InviteResponseStatus]


export const UserSource = {
  self_signup: 'self_signup',
  org_admin_invited: 'org_admin_invited',
  superadmin_invited: 'superadmin_invited'
} as const

export type UserSource = (typeof UserSource)[keyof typeof UserSource]


export const BillingSubscriptionStatus = {
  trialing: 'trialing',
  active: 'active',
  past_due: 'past_due',
  canceled: 'canceled'
} as const

export type BillingSubscriptionStatus = (typeof BillingSubscriptionStatus)[keyof typeof BillingSubscriptionStatus]


export const BillingSignupDraftStatus = {
  pending_verification: 'pending_verification',
  verified: 'verified',
  org_drafted: 'org_drafted',
  plan_selected: 'plan_selected',
  checkout_pending: 'checkout_pending',
  provisioned: 'provisioned',
  abandoned: 'abandoned'
} as const

export type BillingSignupDraftStatus = (typeof BillingSignupDraftStatus)[keyof typeof BillingSignupDraftStatus]


export const OtpPurpose = {
  signup_email_verification: 'signup_email_verification'
} as const

export type OtpPurpose = (typeof OtpPurpose)[keyof typeof OtpPurpose]


export const BillingCreditGrantMode = {
  one_time: 'one_time',
  monthly: 'monthly',
  contract: 'contract'
} as const

export type BillingCreditGrantMode = (typeof BillingCreditGrantMode)[keyof typeof BillingCreditGrantMode]


export const BillingCreditLedgerKind = {
  hold: 'hold',
  debit: 'debit',
  hold_release: 'hold_release',
  refund: 'refund',
  grant: 'grant',
  period_reset: 'period_reset',
  pack_purchase: 'pack_purchase'
} as const

export type BillingCreditLedgerKind = (typeof BillingCreditLedgerKind)[keyof typeof BillingCreditLedgerKind]


export const BillingCapacityGrantScope = {
  period: 'period',
  permanent: 'permanent'
} as const

export type BillingCapacityGrantScope = (typeof BillingCapacityGrantScope)[keyof typeof BillingCapacityGrantScope]


export const EntityProcessingKind = {
  JP: 'JP',
  JA: 'JA',
  SCREENING_INTERVIEW: 'SCREENING_INTERVIEW',
  SCREENING_CALL: 'SCREENING_CALL',
  HUMAN_INTERVIEW: 'HUMAN_INTERVIEW'
} as const

export type EntityProcessingKind = (typeof EntityProcessingKind)[keyof typeof EntityProcessingKind]


export const EntityProcessingStatus = {
  INIT: 'INIT',
  PROCESSED: 'PROCESSED',
  FAILED: 'FAILED',
  DUPLICATE: 'DUPLICATE'
} as const

export type EntityProcessingStatus = (typeof EntityProcessingStatus)[keyof typeof EntityProcessingStatus]
